import React, { createContext, useContext } from 'react';
import { AgreementsCheck } from '../../pages/login/components/SignUpAgreements';

export type LoginProvider = 'kakao' | 'naver' | 'google' | 'apple';

export type Social = {
  provider: LoginProvider;
  name?: string;
  email?: string;
  access_token: string;
};

export interface LoginController {
  leadText: string;

  formRef: React.RefObject<HTMLFormElement>;

  social?: Social;
  setSocial: (s?: Social) => void;
  showApple: boolean;

  userId: string;
  setUserId: (v: string) => void;
  password: string;
  setPassword: (v: string) => void;
  name: string;
  setName: (v: string) => void;
  agreements?: AgreementsCheck;
  setAgreements: (a: AgreementsCheck) => void;

  userIdError?: string;
  passwordError?: string;

  submitEmailPassword: (e: React.FormEvent) => void;
  submitSocialSignUp: (e: React.FormEvent) => void;
  goSignUp: () => void;
  onToken: () => void;
}

const LoginContext = createContext<LoginController | null>(null);

export const LoginProvider: React.FC<React.PropsWithChildren<{ value: LoginController }>> = ({ value, children }) => {
  return <LoginContext.Provider value={value}>{children}</LoginContext.Provider>;
};

export const useLogin = (): LoginController => {
  const ctx = useContext(LoginContext);
  if (!ctx) throw new Error('useLogin must be used within LoginProvider');
  return ctx;
};
